import { CircularProgress } from '@mui/material'
import styles from './LoadingScreen.module.scss'

export function LoadingScreen() {
  return (
    <main className={styles.main} aria-busy="true" aria-label="Loading application">
      <CircularProgress />
      <span>Loading securely…</span>
    </main>
  )
}
